import { useAuthUser } from "../../auth/hooks/useAuthUser";

export function useCanAutotrade () {
  const { user } = useAuthUser();
  // return false;
  return user?.candefi_membership?.plan?.can_autotrade || false;
}